const o=(...o)=>{console.log(o)};export{o as noop};
//# sourceMappingURL=noop.js.map
